import { PagingFilter } from '@/services/models/shared/PagingFilter';
export class DocumentHistoryFilter extends PagingFilter {
    constructor(returnAll = false) {
        super(returnAll);
    }
    options() {
        return super.options();
    }
}
